<template>
  <base-dialog width="560px" show-close :visible.sync="visible" class="sign-user-dialog">
    <template v-slot:header>{{ editUserMap[operation] }}</template>
    <div>
      <div class="row">
        <div class="row-title">签署人姓名</div>
        <control-value
          v-model="extraSignParam.name"
          :control="{ _type: 'text' }"
          @input-val="setUserInfoVal('name', $event)"
          :group-list="groupList"
          class="row-body"
        ></control-value>
      </div>
      <div class="row">
        <div class="row-title">签署人手机号</div>
        <control-value
          v-model="extraSignParam.telephone"
          :control="{ _type: 'text' }"
          @input-val="setUserInfoVal('telephone', $event)"
          :group-list="groupList"
          class="row-body"
        ></control-value>
      </div>
      <div class="row">
        <div class="row-title">证件类型</div>
        <normal-select
          :select-list="credentials"
          :selected-item.sync="signUserInfo.userInfo.type"
          class="row-body"
          size="normal"
        ></normal-select>
      </div>
      <div class="row">
        <div class="row-title">证件编号</div>
        <control-value
          v-model="extraSignParam.number"
          :control="{ _type: 'text' }"
          @input-val="setUserInfoVal('number', $event)"
          :group-list="groupList"
          class="row-body"
        ></control-value>
      </div>
      <div class="row">
        <div class="row-title">签署页码</div>
        <el-input-number
          v-model="signUserInfo.signPosition.page"
          class="row-body number"
          :min="1"
          :controls="false"
        ></el-input-number>
      </div>
      <div class="row">
        <div class="row-title">签署坐标</div>
        <div class="axis">
          <div class="x-axis">
            <span class="prefix">X：</span>
            <el-input-number
              v-model="signUserInfo.signPosition.x"
              :controls="false"
            ></el-input-number>
          </div>
          <div class="y-axis">
            <span class="prefix">Y：</span>
            <el-input-number
              v-model="signUserInfo.signPosition.y"
              :controls="false"
            ></el-input-number>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import { editUserMap, credentials } from "@/views/Backend/AdminEdit/Workflow/components/static"
import { randomString } from "@/utils/common"
import ControlValue from "@/components/Workflow/ControlValue"

export default {
  name: "sign-user-dialog",
  components: { ControlValue, NormalSelect, BaseDialog, BaseButton },
  props: {
    operation: String,
    signUser: Object,
    extra: Object,
    index: Number,
    groupList: Array
  },
  data() {
    return {
      editUserMap,
      credentials,
      visible: false,
      signUserInfo: {
        userInfo: {},
        signPosition: {}
      },
      extraSignParam: {
        name: null,
        telephone: null,
        number: null
      }
    }
  },
  methods: {
    open() {
      this.signUserInfo = this.signUser
      this.extraSignParam =
        this.extra.valueMap.signParams.length >= this.index + 1
          ? this.extra.valueMap.signParams[this.index]
          : this.$options.data().extraSignParam
      this.visible = true
    },
    submit() {
      if (!this.signUserInfo.userInfo.name) {
        this.$message.error("签署人名称不能为空")
        return
      }
      if (!this.signUserInfo.userInfo.telephone) {
        this.$message.error("签署人手机号不能为空")
        return
      }
      if (!this.signUserInfo.userInfo.type) {
        this.$message.error("证件类型不能为空")
        return
      }
      if (!this.signUserInfo.userInfo.number) {
        this.$message.error("证件编码不能为空")
        return
      }
      if (!this.signUserInfo.signPosition.page) {
        this.$message.error("签署页码不能为空")
        return
      }
      if (!this.signUserInfo.signPosition.x || !this.signUserInfo.signPosition.y) {
        this.$message.error("签署坐标不能为空")
        return
      }
      this.extra.valueMap.signParams[this.index] = this.extraSignParam
      this.$emit("submit", this.signUserInfo)
      this.visible = false
    },
    setUserInfoVal(attr, val) {
      this.signUserInfo.userInfo[attr] = val
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-user-dialog {
  .el-select {
    width: 100%;
  }
  .row {
    font-size: 13px;
    padding-bottom: 15px;
    .row-title {
      font-weight: bold;
    }
    .row-body {
      margin-top: 10px;
    }
    .axis {
      margin-top: 10px;
      display: flex;
      align-items: center;
      .prefix {
        position: absolute;
        z-index: 10;
        top: 11px;
        left: 8px;
      }
      .el-input-number {
        width: 100%;
      }
      .x-axis {
        flex: 1;
        margin-right: 10px;
        position: relative;
      }
      .y-axis {
        flex: 1;
        position: relative;
      }
      ::v-deep {
        .el-input-number.is-without-controls .el-input__inner {
          padding-left: 24px;
        }
      }
    }
  }
  .number {
    width: 100%;
  }
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 20px;
      color: unset;
    }
  }
  ::v-deep {
    .el-input-number .el-input__inner {
      text-align: left;
      height: 40px;
      line-height: 40px;
    }
  }
}
</style>
